import React, { useState } from 'react';

interface SelectComboProps {
    options: string[];
    defaultValue?: string;
    onChange: (value: string) => void;
}

export const Combo: React.FC<SelectComboProps> = ({ options, defaultValue = '', onChange }) => {
    const [selectedItem, setSelectedItem] = useState(defaultValue);

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.currentTarget.value;
        setSelectedItem(value);
        onChange(value);
    };

    const createOptions = options.map((option: string, idx: number) => {
        return (
            <option key={idx} value={option}>
                {option}
            </option>
        );
    });

    return (
        <div className="select-container">
            <select value={selectedItem} onChange={handleChange} className="select-items">
                {createOptions}
            </select>
        </div>
    );
};
